import React from 'react';
import { BookOpenIcon, BuildingIcon, EyeIcon, GraduationCapIcon, PresentationIcon, SparklesIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
const icons = [EyeIcon, SparklesIcon, PresentationIcon, GraduationCapIcon, BuildingIcon, BookOpenIcon];
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-40" data-mp="286je3njj4tvb">
      <div className="mx-auto max-w-5xl" data-id="element-41" data-mp="23882p8dl6baz">
        <SectionHeading id="audience-heading" eyebrow="Per chi è" title={<>
              Pensato per professioniste <Accent data-id="element-43" data-mp="2cxrj87dttt2o">che insegnano Lash & Brow.</Accent>
            </>} data-id="element-42" data-mp="2376pax93lcq3" />

        <ul className="mt-12 grid grid-cols-2 gap-4 lg:grid-cols-3" role="list" data-id="element-44" data-mp="2qx13bi55l7bx">
          {audience.map((role, index) => {
          const Icon = icons[index];
          return <li key={role} className="flex flex-col items-center rounded-[20px] bg-brand-paper px-4 py-7 text-center" data-id="element-45" data-mp="1sbkhkl5w0j40" data-mpi={index}>
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-white" data-id="element-46" data-mp="1xa5hskl532sg">
                  <Icon className="h-5 w-5 text-brand-rosewood" strokeWidth={1.5} aria-hidden="true" data-id="element-47" data-mp="2298oe9grph2j" />
                </span>
                <span className="mt-3 font-display text-[1.25rem] font-bold leading-tight text-brand-charcoal sm:text-[1.35rem]" data-id="element-48" data-mp="26c51jknjgkz3">
                  {role}
                </span>
              </li>;
        })}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center text-[15px] leading-relaxed text-brand-charcoal/75 sm:text-[16px]" data-id="element-49" data-mp="2g7gfi0r4ho5s">
          Se vuoi organizzare i tuoi corsi senza creare ogni materiale da zero —{' '}
          <strong className="font-semibold text-brand-charcoal" data-id="element-50" data-mp="2q15sfedz74t3">questo sistema è pensato per te.</strong>
        </p>
      </div>
    </section>;
}